export default {
      id: "morePanelActionsBtn-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#morePanelActionsBtn",
      toString: function () {
        return this.url;
      }
    }